import React from 'react';
import {curry} from 'ramda';
import {FrameRate} from '@accurate-player/accurate-player-core';

import AudioTracks from './AudioTracks';
import {
    AudioTracksClick,
    AudioTrackData,
    TempChannel,
} from './AudioTracksTypes';

export interface AudioTracksContainerProps {
    audioTracks: AudioTrackData[];
    onlyMonoAudioAvailable: boolean;
    frameRate: FrameRate;
    onAudioTrackClick: AudioTracksClick;
    onAudioChannelClick: TempChannel;
}

export const onTrackClick = curry((props: AudioTracksContainerProps, trackData: AudioTrackData) => {
    const {audioTracks, onAudioTrackClick} = props;
    
    onAudioTrackClick(audioTracks, trackData);
});

export const onChannelClick = curry((props: AudioTracksContainerProps, trackData: AudioTrackData, channel: number) => {
    const {audioTracks, onAudioChannelClick} = props;
    
    onAudioChannelClick(channel, audioTracks, trackData);
});

export default function AudioTracksContainer(props: AudioTracksContainerProps) {
    const {
        audioTracks,
        onlyMonoAudioAvailable,
        frameRate,
    } = props;
    const handleAudioTrackClick = onTrackClick(props);
    const handleAudioChannelClick = onChannelClick(props);
    
    return (
        <AudioTracks
            audioTracks={audioTracks}
            onlyMonoAudioAvailable={onlyMonoAudioAvailable}
            frameRate={frameRate}
            onAudioTrackClick={handleAudioTrackClick}
            onAudioChannelClick={handleAudioChannelClick}
        />
    );
}
